import Vue from 'vue'

import VueRouter from 'vue-router'

import { routes } from './routes'

import axios from 'axios'

import store from '../store/index.js'


Vue.use(VueRouter);

let router = new VueRouter({
    mode: 'hash',//history
    routes
})

router.beforeEach((to, from, next) => {
    if(to.name == "Mancomuno" || to.name == "Participe" || to.name == "Suscripcion")
    {
        var json = {
            "Token":to.params.id,
            "Tipo": to.name,
            "Fecha": new Date().toISOString(),
            "Ip": "",
            "Terminal":"WEB", 
            "User":"forms"
        };
        axios({
            method: 'post',
            url: 'https://'+store.state.url+':5001/api/altas/TokenValidateAlta',
            data: json
        })
        .then(function (response) {
            var data = response.data
            if(data.success){
                next();
            }else{
                next({name:"NotFound"})
            }
            
        })
        .catch(function () {
            next();
        })
    }else{
        next();
    }

}
);

export default router